<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="'Save'"
  >
    <template slot="header">
      <span>Select Delay Reason WO# {{ item ? item.wo_number : '' }}</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          class="pb-0"
        >
          <v-select
            v-model="selectedReasonId"
            :items="reasons"
            item-text="name"
            item-value="id"
          >
            <template #label>
              <span>Delay Reason</span>
            </template>
            <template #item="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer; text-transform: uppercase"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
            </template>
            <!-- eslint-disable-next-line vue/no-template-shadow -->
            <template #selection="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer; text-transform: uppercase"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    item: null,
    reasons: [],
    selectedReasonId: null,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
  },
  methods: {

    async getReasons() {
      this.reasons = await this.$api.productionScheduleDelayReason.get();
    },

    async submit() {
      const submitModel = {
        id: this.item.id,
        wip_panel_schedule_delay_reason_id: this.selectedReasonId,
      };

      const res = await this.$api.wipPanelSchedule.store(submitModel, 'delay-reason');

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    open(item) {
      this.item = item;
      if (this.item.wip_panel_schedule_delay_reason_id) {
        this.selectedReasonId = this.item.wip_panel_schedule_delay_reason_id;
      } else {
        this.selectedReasonId = null;
      }
      this.getReasons();
      this.$refs.dialogBox.open();
    },
  },
};
</script>
